<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
//eslint-disable-next-line
import AuthenticationHistory from "../../../../src/components/certificate-authentication/authenticationHistory.vue";
/**
 * Starter component
 */
export default {
    page: {
        title: "Collections List",
        meta: [{ name: "description", content: appConfig.description }],
    },
    components: { Layout, PageHeader, AuthenticationHistory },
    data() {
        return {
            title: "Authentication History",
            items: [
                // {
                //     text: "Clients",
                //     href: "/clients",
                // },
            ],
        };
    },
    mounted() {},
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <AuthenticationHistory />
    </Layout>
</template>
